
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"remove\":true,\"id\":1}!css?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-bbdde23c&scoped=true!postcss!sass!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CenterCommon.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CenterCommon.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-bbdde23c!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CenterCommon.vue"),
  /* scopeId */
  "data-v-bbdde23c",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./views/anchor/center/CenterCommon.vue
// module id = 392
// module chunks = 0